<template>

	<div class="modal">

		<div class="modal-wrap">

			<div class="modal-inner">

				<h2 class="modal-title">{{ title }}<span class="close" @click="close">X</span></h2>

				<div class="modal-inner-scroll">

					<h3 class="modal-inner-title" v-if="!theType">There Are 2 Types Of Report...</h3>

					<div>

						<div :class="{'report-type':true}" v-if="!theType">

							<h4 class="report-type-title">Visual Report</h4>

							<p>This option allows you to create a PDF showing the visual components you see on the project page such as the graph. Individual elements can be toggled on and off. This option will show a maximum of 50 keywords.</p>

							<a :href="'/report/'+project" :class="{'large-button':true,mini:true}" target="_blank">Create Visual Report</a>

						</div>

						<div :class="{'report-type':true}" v-if="!theType">

							<h4 class="report-type-title">Keyword Download</h4>

							<p>This option allows you to download some or all of the keywords in CSV or PDF format. Filters used when searching the keyword table will dictate what is added to the download.</p>

							<span :class="{'large-button':true,mini:true}" @click="setType('csv')">Create CSV</span>

							<span :class="{'large-button':true,mini:true}" @click="setType('pdf')">Create PDF</span>

						</div>

						<div :class="{'report-type':true,full:true}" v-if="theType">
							
							<div class="input-wrap" v-if="theType==='pdf'">

								<FormInput 
									type="text"
									v-model="pdfTitle" 
									:required="false"
									placeholder="No title will be shown"
									:noMarginBottom="true"
									label="Enter a title for the PDF below, this sits at the top of the table and defaults to the projects name, if you delete the contents it won't be shown."
								/>

							</div>

							<div v-if="pages>1">

								<h4 class="report-type-title">Do you want to download all the results?</h4>

								<p>You can create a {{theType.toUpperCase()}} containing all the rows in the table or just the current page that is selected (page {{page}}).</p>

								<p v-if="extraText" v-html="extraText" />

								<span :class="{'large-button':true,mini:true}" @click="download (page)" v-html="'Page ' + page + ' only'" />

								<span :class="{'large-button':true,mini:true}" @click="download (0)">All Pages</span>

							</div>

							<div v-if="pages===1&&theType==='pdf'">

								<span :class="{'large-button':true,mini:true}" @click="download (0)">Create PDF</span>

							</div>

						</div>

					</div>

				</div>

			</div>

		</div>

	</div>

</template>

<script>
import { mapMutations } from 'vuex'
import FormInput from './Form/Input.vue'
export default {
	name: 'ReportOptions',
	components: { FormInput },
	props: {
		type: {
			type: String,
			default: '' // csv or pdf
		},
		project: {
			type: String,
			default: ''
		},
		pages: {
			type: Number,
			default: 1
		},
		page: {
			type: Number,
			default: 1
		},
		extraText: {
			type: String,
			default: ''
		},
		projectName: {
			type: String,
			default: ''
		}
	},
	data() {

		return {

			theType: '',
			pdfTitle: ''

		}

	},
	computed: { 
		title () {

			return "Create A Report";

		}

    },
	created () {

		this.theType = this.type;
		this.pdfTitle = this.projectName;

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		setType (type) {

			this.theType = type;

			if ( this.pages === 1 && type === 'csv' ) {

				this.$emit('download',type,'all',this.pdfTitle);

			}

		},

		download (page) {

			this.$emit('download',this.theType,page,this.pdfTitle);

		},

		close () {

			this.$emit('close');

		}

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.modal {

	.modal-inner-title {

		margin-bottom: 20px;

	}

	.report-type {

		margin-top: 30px;

		.input-wrap {

			margin-bottom: 20px;

		}

		&:first-child {

			margin-top: 0;

		}

		.report-type-title {

			margin: 0 0 5px;

		}

		p { 
			margin: 0 0 15px;
			padding: 0;
			max-width: 700px;
			font-size: 14px;
		}

		.large-button {

			margin: 0;

		}

	}

}

@media screen and (min-width: 768px) {
	.modal {

		.report-type {

			display: inline-block;
			vertical-align: top;
			text-align: left;
			width: 44%;
			margin-right: 4%;
			margin-top: 0;

			&.full {
				width: 100%;
				margin-right:0;
			}

			.report-type-title {



			}

		}

		.modal-inner-scroll {

			.modal-inner-title {

				text-align: left;

			}

		}

	}
}
</style>